import { Component } from "@angular/core";

/**
 * A self-contained, in-depth walkthrough of the XWAI assistant: what it is,
 * how a streamed answer is structured, and an annotated tour of each specialist
 * output. Purely presentational — all visuals are static mockups (no backend),
 * so it can be shown anywhere (we render it inside a drawer over the chat).
 */
@Component({
  selector: "app-xwai-guide",
  templateUrl: "./xwai-guide.component.html",
  styleUrls: ["./xwai-guide.component.less"],
  standalone: true,
})
export class XwaiGuideComponent {
  /** Starter prompts users can copy to get a feel for what XWAI can do. */
  protected readonly examplePrompts: string[] = [
    "What are the parameters for job ABC-123?",
    "Compare the inversion parameters of my last two jobs.",
    "Show me the lineage of job ABC-123.",
    "Plot the trace fit over iterations for these two jobs.",
    "Show the velocity model for job ABC-123.",
    "How is the trace fit distributed along the inline for the final iteration?",
  ];

  /** Smooth-scroll a section into view within the drawer (no route fragment change). */
  protected scrollTo(id: string, event: Event): void {
    event.preventDefault();
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
